import * as React from "react";

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10.682}
    height={10.682}
    {...props}
  >
    <path
      d="M215.341 140a.89.89 0 0 0-.89.89v3.561h-3.561a.89.89 0 0 0 0 1.78h3.561v3.561a.89.89 0 0 0 1.78 0v-3.561h3.561a.89.89 0 0 0 0-1.78h-3.561v-3.561a.89.89 0 0 0-.89-.89z"
      transform="translate(-210 -140)"
      style={{
        fill: "#00446e",
      }}
    />
  </svg>
);

export default SvgComponent;
